import * as React from 'react'

import QueryEmulatorInput from '../QueryEmulatorInput/QueryEmulatorInput'
import LockIcon from '../../images/lock-icon.svg'
import { QuerySizesFieldProps } from './'

const QuerySizesField: React.SFC<QuerySizesFieldProps> = ({
  onSizeChange,
  upscaleWidth,
  upscaleHeight,
  originalHeight,
  originalWidth
}) => {
  const handleWidthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const widthValue = parseInt(e.currentTarget.value)

    if (widthValue) {
      const aspectRatio = originalHeight / originalWidth
      const heightValue = Math.round(widthValue * aspectRatio)

      onSizeChange(widthValue, heightValue)
    } else {
      onSizeChange(0, 0)
    }
    
  }
  const handleHeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const heightValue = parseInt(e.currentTarget.value)
 
    if (heightValue) {
      const aspectRatio = originalWidth / originalHeight
      const widthValue = Math.round(heightValue * aspectRatio)

      onSizeChange(widthValue, heightValue)
    } else {
      onSizeChange(0, 0)
    }
  }

  const upscaleHeightValue = upscaleHeight ? upscaleHeight.toString() : ''
  const upscaleWidthValue = upscaleWidth ? upscaleWidth.toString() : ''

  return (
    <>
      <QueryEmulatorInput
        placeholder={originalWidth}
        value={upscaleWidthValue}
        onChange={handleWidthChange}
        postfix='W'
      />

      <object data={LockIcon} type="image/svg+xml" />

      <QueryEmulatorInput
        placeholder={originalHeight}
        value={upscaleHeightValue}
        onChange={handleHeightChange}
        postfix='H'
      />
    </>
  )
}

export default QuerySizesField
